var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDummyProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 125,
    height: 125,
    viewBox: "0 0 125 125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3607",
    "data-name": "Group 3607",
    transform: "translate(-164 -97)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_282",
    "data-name": "Rectangle 282",
    width: 125,
    height: 125,
    rx: 15,
    transform: "translate(164 97)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "user",
    transform: "translate(198.526 128.249)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3603",
    "data-name": "Group 3603",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3602",
    "data-name": "Group 3602"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3327",
    "data-name": "Path 3327",
    d: "M127.02,32.456a16.228,16.228,0,1,0-16.228-16.228A16.271,16.271,0,0,0,127.02,32.456Z",
    transform: "translate(-99.042)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3328",
    "data-name": "Path 3328",
    d: "M79.992,259.648a15.131,15.131,0,0,0-1.63-2.976,20.171,20.171,0,0,0-13.96-8.787,2.987,2.987,0,0,0-2.055.5,17.3,17.3,0,0,1-20.409,0,2.659,2.659,0,0,0-2.055-.5,20.025,20.025,0,0,0-13.96,8.787,17.446,17.446,0,0,0-1.63,2.976,1.507,1.507,0,0,0,.071,1.346,28.27,28.27,0,0,0,1.913,2.835,26.93,26.93,0,0,0,3.26,3.685,42.455,42.455,0,0,0,3.26,2.835,32.316,32.316,0,0,0,38.55,0,31.156,31.156,0,0,0,3.26-2.835,32.721,32.721,0,0,0,3.26-3.685,24.849,24.849,0,0,0,1.913-2.835A1.209,1.209,0,0,0,79.992,259.648Z",
    transform: "translate(-24.165 -214.224)",
    fill: "#202020"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDummyProfile);
export default __webpack_public_path__ + "static/media/dummyProfile.ced0177f970e057e5a2dd0443aa430bd.svg";
export { ForwardRef as ReactComponent };